export const DEFAULT_GROUP_NAME = 'Services';

export const SORTED_SERVICE_TEST_FLAG = 'client_proprofile_sorted_services_08062021_atl3808';
export const SORTED_SERVICE_TEST_PERCENT = 0.5;

export const SEE_ALL_SERVICES_POPUP_TEST_FLAG = 'client_proprofile_seeallservices_07222021_atl3806';
export const SEE_ALL_SERVICES_POPUP_TEST_PERCENT = 0.5;

export const DP_273_TEST_REVIEW_ORDERING_NAME = 'client_proprofile_review_ordering_dp273_20230810';
export const DP_273_TEST_REVIEW_ORDERING_PERCENT = 0.5;
